import { Link } from 'react-router-dom';
import { ShoppingBag, Shield, MessageCircle, Search, Download, Star } from 'lucide-react';
import './AboutPage.css';

export default function AboutPage() {
  return (
    <div className="about-page fade-in">

      {/* Hero */}
      <div className="about-hero card">
        <div className="about-hero-icon">
          <ShoppingBag size={36} />
        </div>
        <h2>GLA Exchange</h2>
        <p className="about-tagline">Campus Marketplace for GLA University Students</p>
        <p className="about-desc">
          A peer-to-peer platform exclusively for GLA University, Mathura. Buy and sell notes,
          gadgets, clothing and more — directly with fellow students. No middlemen, no platform fees.
        </p>
        <div className="about-version-badge">v1.0.0 · Built for GLA University</div>
      </div>

      {/* Features */}
      <h3 className="about-section-title">What you can do</h3>
      <div className="about-features">
        {[
          { icon: ShoppingBag,    title: 'Buy & Sell',       desc: 'List items for sale or browse the marketplace. Notes, electronics, clothing, gaming gear and more.' },
          { icon: MessageCircle,  title: 'Direct Chat',       desc: 'Message any student directly within the app. No need to share numbers until you want to.' },
          { icon: Search,         title: 'Lost & Found',      desc: 'Post lost items or items you found on campus. Help your fellow students.' },
          { icon: Shield,         title: 'Safe Community',    desc: 'Only GLA students can join. Every user is verified through Google login.' },
          { icon: Star,           title: 'Seller Ratings',    desc: 'Review sellers after a transaction to help the community make better decisions.' },
          { icon: Download,       title: 'Install as App',    desc: 'Add GLA Exchange to your home screen for a native app experience on any device.' },
        ].map(f => (
          <div key={f.title} className="about-feature-card card">
            <div className="about-feature-icon">
              <f.icon size={20} />
            </div>
            <div>
              <h4 className="about-feature-title">{f.title}</h4>
              <p className="about-feature-desc">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Rules */}
      <h3 className="about-section-title">Community Guidelines</h3>
      <div className="card about-rules">
        {[
          '✅  Only GLA University students may use this platform.',
          '✅  List only items you personally own and intend to sell.',
          '✅  Prices must be fair and clearly stated.',
          '✅  No prohibited, illegal or adult items.',
          '✅  Respect other students — no harassment or spam.',
          '✅  Report suspicious listings using the Report button.',
          '✅  Admin reserves the right to remove any listing or user.',
        ].map(rule => (
          <div key={rule} className="about-rule">{rule}</div>
        ))}
      </div>

      {/* Built by */}
      <div className="card about-built-by">
        <p className="text-muted" style={{ fontSize: '0.875rem', textAlign: 'center' }}>
          Built with ❤️ for GLA University students · Mathura, Uttar Pradesh
        </p>
        <p className="text-muted" style={{ fontSize: '0.78rem', textAlign: 'center', marginTop: 4 }}>
          For support or feedback, contact the admin through the platform.
        </p>
        <Link to="/install" className="btn btn-primary" style={{ marginTop: 'var(--space-4)', alignSelf: 'center' }}>
          <Download size={16} /> Install App
        </Link>
      </div>

    </div>
  );
}